import React from 'react'
import empty_image from '../../assets/images/13525-empty.gif'
import './EmptyList.css'

const EmptyList = () => {
  return (
    <div className='emptygif'>
        <img src={empty_image} alt=''/>
    </div>
  )
}

export default EmptyList